import { useQuery } from "@tanstack/react-query";
import { getPartners } from "../api/contactsApi";
import { useAuth } from "../../../Context/AuthContext";

export const usePartners = ({ enabled = false }) => {
  const auth = useAuth();
  let { token } = auth.getSessionData();

  return useQuery({
    queryKey: ["partners_contacts"],
    queryFn: async () => await getPartners({ token }),
    refetchOnWindowFocus: false,
    initialData: [],
    enabled: enabled,
  });
};

export default usePartners;
